// extracted by mini-css-extract-plugin
export default {"ml6":"tooltipExpression_ml6__m-5z6","operatorDivide":"tooltipExpression_operatorDivide__8U3QB","textCenter":"tooltipExpression_textCenter__jEAls"};